import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import Home from "./pages/home";
import Cpcs from "./pages/cpcs";
import Nvq from "./pages/nvq";
import Npors from "./pages/npors";
import ContactUs from "./pages/contactus";
import Training from "./pages/training";
import Login from "./pages/login";
import Register from "./pages/register";
import nporsRoutes from "./routes/nporsroutes";
import cpcsRoutes from "./routes/cpcsroutes";

function App() {
  return (
    <Router>
      <Helmet>
        <title>Home | Alpha Construction Training</title>
        <meta
          name="description"
          content="Alpha Constructions offers CPCS, NPORS & NVQ training to help you grow your skills and career. Contact us by email, phone, social media, or our form."
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cpcs" element={<Cpcs />} />
        <Route path="/npors" element={<Npors />} />
        <Route path="/nvq" element={<Nvq />} />
        {/* <Route path="/training" element={<Training />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} /> */}
        <Route path="/contactus" element={<ContactUs />} />

        {nporsRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}

        {cpcsRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
